import * as React from "react";
import { StyledTextField } from "../../../../../styles/form";
import { FormAutoSelectError } from "../../../../../styles/general";
import Select, { components } from "react-select";
import MenuItem from "@material-ui/core/MenuItem";

export const PeoplePickerAutoCompleteComponent: any = ({
  input,
  label,
  name,
  disabled,
  onChange,
  meta: { touched, error },
  children,
  data,
  classes,
  value,
  isMulti,
  onInputChange,
  menuIsOpen,
  ...custom
}: {
  input: any;
  label: any;
  name: any;
  disabled: boolean;
  onChange: any;
  meta: any;
  children: any;
  custom: any;
  data: any;
  value: any;
  classes: any;
  isMulti: boolean;
  onInputChange: any;
  menuIsOpen: boolean;
}) => {
  return (
    <React.Fragment>
      <Select
        className={[touched && error ? "req-field-error-autosel" : ""]}
        options={data}
        components={modifiedComponents}
        isDisabled={disabled}
        onBlur={input.onBlur}
        value={input.value}
        placeholder="Please Select"
        isMulti={isMulti || false}
        error={touched && error ? true : false}
        onInputChange={onInputChange}
        menuIsOpen={menuIsOpen}
        {...input}
        {...custom}
      />
      {touched && error && <FormAutoSelectError>{error}</FormAutoSelectError>}
    </React.Fragment>
  );
};

const MultiValue = (props: any) => (
  <components.MultiValue {...props}>
    {props.data.chipLabel}
  </components.MultiValue>
);

function inputComponent({
  index,
  key,
  inputRef,
  ...props
}: {
  index: any;
  key: any;
  inputRef: any;
  props: any;
}) {
  return <div key={key} ref={inputRef} {...props}></div>;
}

const modifiedComponents = {
  Control,
  Option,
  MultiValue,
};

function Control(props: any) {
  return (
    <StyledTextField
      setwidth={props.selectProps.name}
      InputProps={{
        inputComponent,
        inputProps: {
          children: props.children,
          className: props.selectProps.classes
            ? props.selectProps.classes.input
            : "autoselect-material",
          ref: props.innerRef,
          ...props.innerProps,
        },
      }}
    />
  );
}

function Option(props: any) {
  return (
    <MenuItem
      key={props.data.key}
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      {...props.innerProps}
      style={{
        zIndex: 999,
        fontWeight: props.isSelected ? 500 : 400,
        margin: "5px 0px",
      }}
    >
      {props.children}
    </MenuItem>
  );
}
